// DashboardTables.js
import React from "react";
import { SimpleGrid } from "@chakra-ui/react";
import ComplexTable from "./components/ComplexTable";

const DashboardTables = ({ branchData, serviceData, itemData }) => (
  <SimpleGrid
    columns={{ base: 1, md: 2, xl: 3 }} // 1 on mobile, 2 on medium, 3 on extra large screens
    spacing={4}
    mt={6}
  >
            <ComplexTable title="Orders per Branch" tableData={branchData} dataKey="ORDERS" labelKey="Orders" />
            <ComplexTable title="Qty vs Services" tableData={serviceData} dataKey="ORDERS" labelKey="Quantity" />
            <ComplexTable title="Qty vs Items" tableData={itemData} dataKey="ORDERS" labelKey="Quantity" />
  </SimpleGrid>
);

export default DashboardTables;